import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  dialogContainer: {
    margin: 'auto',
    position: 'relative',
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '11px',
    justifyContent: 'center',
  },

  buttonSubmit: {
    marginBottom: 10,
    marginTop: 5,
    borderRadius: '20px',
    backgroundColor: '#000',
    color: '#fff',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
  },
  buttonClear: {
    marginBottom: 10,
    marginTop: 5,
    borderRadius: '20px',
    backgroundColor: '#000',
    color: '#fff',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
  },
  linkCreate: {
    marginTop: '10px',
    fontWeight: 500,
    textAlign: 'center',
  },
  roomLink: {
    width: '100%',
    marginLeft: 8,
    margin: '10px 0',
  },
  fileInput: {
    width: '100%',
    margin: '10px 0 10px 15px',
  },
  button: {
    width: '10px',
    height: '77%',
    marginTop: 7,
  },

  roomSchedule: {
    width: '46%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}))
